import {cloneDeep} from 'lodash';
import {createImageObject} from '../utils';
import {intelFormConfig, designFormConfig} from '@/views/Image/market/utils/formConfig.js';
import {defaultIntelFormData, defaultDesignFormData} from '@/views/Image/market/utils/formData.js';
import {
    tabConfig,
    defaultIntelTarget,
    defaultDesignTarget,
    placeHolder,
    historyParams,
    openIndustry
} from '@/views/Image/market/utils/constants.js';


export default {
    namespaced: true,
    state: {
        toolBarLoading: false,
        displayImg: [],
        recordImg: [],
        activeTab: 'intelForm',
        displayImgType: '',
        // 记录图片创作时的构图方式，如果是仅主体的，高级设计的时候要拼接有抠图标签；其他类型，拼接不抠图标签
        displayImgComposition: '',
        displayImgCombinationInfo: {},
        tabConfig,
        historyParams,
        placeHolder,
        industryList: [],
        intelFormConfig: cloneDeep(intelFormConfig),
        designFormConfig: cloneDeep(designFormConfig),
        intelFormData: cloneDeep(defaultIntelFormData),
        designFormData: cloneDeep(defaultDesignFormData),
        targetCountData: {
            intelForm: cloneDeep(defaultIntelTarget),
            designForm: cloneDeep(defaultDesignTarget)
        },
        canSubmit: {
            intelForm: true,
            designForm: true
        },
        formRef: {
            intelForm: null,
            designForm: null
        },
        pageLoadingStatus: {
            show: false,
            title: ''
        }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let update of updates) {
                state[update.key] = update.value;
            }
        },
        UPDATE_FORM_DATA(state, {form, key, value}) {
            state[form] = {...state[form], [key]: value};
        },
        CHANGE_CAN_SUBMIT(state, data) {
            state.canSubmit = {...state.canSubmit, ...data};
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_TARGET_COUNT(state, {form, value}) {
            state.targetCountData[form] = {...state.targetCountData[form], ...value};
        }
    },
    actions: {
        updateFormData({commit}, data) {
            const {form, key, value} = data;
            commit('UPDATE_FORM_DATA', {
                form,
                key,
                value
            });
        },
        changeActiveTab({commit}, data) {
            commit('UPDATE_COMMON_STATE', {
                key: 'activeTab',
                value: data
            });
        },
        changeDesignFormSubmit({commit}, data) {
            commit('CHANGE_CAN_SUBMIT', {
                designForm: Boolean(data.length)
            });
        },
        changeIntelFormSubmit({commit}, data) {
            commit('CHANGE_CAN_SUBMIT', {
                intelForm: Boolean(data.length)
            });
        },
        changeTargetCount({commit}, data) {
            commit('CHANGE_TARGET_COUNT', data);
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        },
        // 获取图片常量数据，行业选项需要用到
        async getImageTplConstants({commit, state}, model) {
            try {
                const resData = await model.imageCreate.getImageTplConstants({productLine: 'QINGDUO'});
                // ToDo，如果行业不是直接使用常量list，而是要有个性化逻辑的话，需要在这里进行重定义，或者直接改成静态配置options
                const allIndustryList = resData?.industry?.map(item => {
                    return {
                        value: `${item.index > 1 ? item.index : ''}`,
                        label: item.label
                    };
                });
                const industryList = allIndustryList.filter(item => openIndustry.includes(item.label));
                let designFormConfig = state.designFormConfig;
                let industryIndex = designFormConfig.findIndex(item => item.name === 'industry');
                designFormConfig[industryIndex].params.options = industryList;

                commit('UPDATE_MULTIPLE_STATES', [
                    {
                        key: 'designFormConfig',
                        value: designFormConfig
                    },
                    {
                        key: 'industryList',
                        value: industryList
                    }
                ]);
            }
            catch (err) {
                throw err;
            }
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    const recordList = i.records;
                    return recordList;
                }).filter(item => item !== undefined);

                commit('UPDATE_COMMON_STATE', {
                    key: 'recordImg',
                    value: recordImgList
                });
            }
            catch (err) {
                throw err;
            }
        },
        resetFromData({commit, state}) {
            const {activeTab} = state;
            const form = `${activeTab}Data`;
            const formVal = cloneDeep(
                activeTab === 'intelForm'
                ? defaultIntelFormData : defaultDesignFormData
            );
            const targetVal = cloneDeep(
                activeTab === 'intelForm'
                ? defaultIntelTarget : defaultDesignTarget
            );

            commit('UPDATE_MULTIPLE_STATES', [
                {
                    key: form,
                    value: formVal
                },
                {
                    key: 'toolBarLoading',
                    value: false
                }
            ]);
            commit('CHANGE_TARGET_COUNT', {
                form: activeTab,
                value: targetVal
            });
        },
        async handleIntelFormSubmit({commit, state}, {model, data: {type, params}}) {
            const {targetCountData, activeTab, intelFormData, designFormData} = state;
            const targetCount = targetCountData[activeTab].targetCount;
            const ext =  {
                activeTab,
                targetCountData,
                displayImgType: 'intel',
                intelFormData: intelFormData
            };
            const finalParams = {
                ...params,
                targetCount,
                ext: JSON.stringify(ext)
            };
            const baseDisplayImg = Array.from({
                length: targetCount
            }, (_, i) => createImageObject({
                recordId: i,
                ratioNum: params.ratioNum
            }));
            const urlMapping = {
                combination: 'combinationGenImage',
                background: 'intelligentGenBackground',
                mainBody: 'intelligentGenSubject'
            };
            commit('UPDATE_COMMON_STATE', {
                key: 'displayImg',
                value: baseDisplayImg
            });
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const res = await model.imageCreate[urlMapping[type]](finalParams);
                const displayImg = res.map(i => createImageObject({
                    url: i.url,
                    recordId: i.recordId,
                    width: i.width,
                    height: i.height,
                    taskId: i.taskId,
                    templateId: i.templateId
                }));

                commit('UPDATE_MULTIPLE_STATES', [
                    // 更新展示区图片
                    {
                        key: 'displayImg',
                        value: displayImg
                    },
                    // 更新展示区图片类型
                    {
                        key: 'displayImgType',
                        value: 'intel'
                    },
                    // 更新展示区图片创作的构图tab
                    {
                        key: 'displayImgComposition',
                        value: type
                    }
                ]);
                // 联动底图带入逻辑
                commit('UPDATE_FORM_DATA', {
                    form: 'designFormData',
                    key: 'bgBase',
                    value: {
                        ...designFormData.bgBase,
                        value: {
                            ...designFormData.bgBase.value,
                            bringComposition: type,
                            bringCombination: intelFormData.composition.value,
                            bringUrlList: displayImg
                        }
                    }
                });
                return displayImg;
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        },
        // submit方法在表单组件里，单独写一个方法更新loading状态，以及结果区的骨架屏数据
        changeLoadingStatus({commit}, {loading, targetCount, ratioNum = 1}) {
            commit('CHANGE_TOOLBAR_LOADING', loading);
            // loading态，且有骨架屏数量，则生成骨架屏的结果区占位数据
            if (typeof targetCount === 'number') {
                const baseDisplayImg = Array.from({
                    length: targetCount
                }, (_, i) => createImageObject({
                    ratioNum: ratioNum,
                    recordId: i
                }));
                commit('UPDATE_COMMON_STATE', {
                    key: 'displayImg',
                    value: baseDisplayImg
                });
            }
        },
        // 在edit表单组件里做完了前置生成图片的动作 ，此处仅负责更新创作结果区的内容
        async handleDesignFormSubmit({commit}, {data}) {
            const displayImg = data.map(item => createImageObject({
                ...item
            }));
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                },
                // 更新展示区图片类型
                {
                    key: 'displayImgType',
                    value: 'design'
                }
            ]);
        }
    },
    getters: {
        formExt: state => {
            return {
                industryList: state.industryList,
                displayImg: state.displayImg,
                displayImgType: state.displayImgType,
                displayImgCombinationInfo: state.displayImgCombinationInfo,
                displayImgComposition: state.displayImgComposition
            };
        }
    }
};
